import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { Coral, CoralProps } from './Coral'

export const CoralRegistration = createRegisterableComponent(
    'coral',
    (props: Omit<CoralProps, 'onEvent'>, services) => (
        <Coral
            storyID={props.storyID}
            storyURL={props.storyURL}
            articleCommentsEnabled={props.articleCommentsEnabled}
            horizontalSpacing={props.horizontalSpacing}
            onEvent={services.onEvent}
        />
    ),
)
